var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.212 15C3.8665 15 3.57825 14.8845 3.34725 14.6535C3.11625 14.4225 3.0005 14.134 3 13.788V4.212C3 3.8665 3.11575 3.57825 3.34725 3.34725C3.57875 3.11625 3.867 3.0005 4.212 3H9.01425V3.75H4.212C4.0965 3.75 3.9905 3.798 3.894 3.894C3.7975 3.99 3.7495 4.096 3.75 4.212V13.7887C3.75 13.9038 3.798 14.0095 3.894 14.106C3.99 14.2025 4.09575 14.2505 4.21125 14.25H9.01425V15H4.212ZM12.3465 11.6542L11.82 11.1143L13.5592 9.375H6.894V8.625H13.5592L11.8193 6.885L12.3458 6.3465L15 9L12.3465 11.6542Z",
    fill: "#16304F",
    stroke: "#16304F",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.20a68312d845cc18dfb73bdd6fd9df76.svg";
export { ForwardRef as ReactComponent };